// extracted by mini-css-extract-plugin
export default {"wrapper":"HomePage_wrapper__OEC8V","right":"HomePage_right__g00Vs"};